import { storyTourConfig } from './storyTourConfig'
import { toolbarTourConfig } from './toolbarTourConfig'
import { backgroundImageTourConfig } from './backgroundImageTourConfig'
import { backgroundColorTourConfig } from './backgroundColorTourConfig'
import { createCourseTourConfig } from './createCourseTourConfig'
import { createLessonTourConfig } from './createLessonTourConfig'
import { scenarioTourConfig } from './scenarioTourConfig'
import { quizTourConfig } from './quizTourConfig'
import { infographicsTourConfig } from './infographicsTourConfig'
import { interactiveTourConfig } from './interactiveTourConfig'
import { worldScenarioTourConfig } from './worldScenarioTourConfig'
import { addContentTourConfig } from './addContentTourConfig'

export const tourConfigs = {
    'toolbar-guide': toolbarTourConfig,
    'story-generation': storyTourConfig,
    'scenario-generation': scenarioTourConfig,
    'quiz-generation': quizTourConfig,
    'infographics-generation': infographicsTourConfig,
    'interactive-generation': interactiveTourConfig,
    'world-scenario-generation': worldScenarioTourConfig,
    'add-content-generation': addContentTourConfig,
    'background-image-settings': backgroundImageTourConfig,
    'background-color-settings': backgroundColorTourConfig,
    'create-course': createCourseTourConfig,
    'create-lesson': createLessonTourConfig,
    // Add more tours here as they are created
}
